import { has } from 'lodash';
import { MAIN_ITEM_TYPE_VALUES } from '@wix/wix-vod-constants/app-settings';
import * as dealInfoHelpers from './deal-info-helpers';
import { isFree, isRentEnabled, isSaleEnabled, isBought, isRented } from '../ui-selectors/video/pricing';
export let BUY_BUTTON_DISPLAY_TYPES = /*#__PURE__*/function (BUY_BUTTON_DISPLAY_TYPES) {
  BUY_BUTTON_DISPLAY_TYPES["BUY"] = "buy";
  BUY_BUTTON_DISPLAY_TYPES["RENT"] = "rent";
  BUY_BUTTON_DISPLAY_TYPES["BUY_FROM"] = "buyFrom";
  BUY_BUTTON_DISPLAY_TYPES["NONE"] = "none";
  return BUY_BUTTON_DISPLAY_TYPES;
}({});
export let PLAY_BUTTON_DISPLAY_TYPES = /*#__PURE__*/function (PLAY_BUTTON_DISPLAY_TYPES) {
  PLAY_BUTTON_DISPLAY_TYPES["PLAY_VIDEO"] = "play-video";
  PLAY_BUTTON_DISPLAY_TYPES["WATCH_NOW"] = "watch-now";
  PLAY_BUTTON_DISPLAY_TYPES["WATCH_TRAILER"] = "watch-trailer";
  PLAY_BUTTON_DISPLAY_TYPES["WATCH_PREVIEW"] = "watch-preview";
  PLAY_BUTTON_DISPLAY_TYPES["NONE"] = "none";
  return PLAY_BUTTON_DISPLAY_TYPES;
}({});
export let PLAY_BUTTON_TYPES = /*#__PURE__*/function (PLAY_BUTTON_TYPES) {
  PLAY_BUTTON_TYPES["PLAY"] = "play";
  PLAY_BUTTON_TYPES["TRAILER_OR_PREVIEW"] = "trailer_or_preview";
  return PLAY_BUTTON_TYPES;
}({});
// Todo: remove. Use widget/ui-selectors/video-access
export function getBuyButtonDisplayTypeWhenInOverlay(_ref) {
  let {
    settings,
    videoItem,
    channelData,
    showChannelCover
  } = _ref;
  // case when user has not yet selected any video
  if (showChannelCover) {
    // only show buy button for featured video or when a video is ended. Otherwise no buy button
    if (mainItemIsChannelCover(settings)) {
      return BUY_BUTTON_DISPLAY_TYPES.NONE;
    }
  }
  return getBuyButtonDisplayType(channelData, videoItem);
}
function canAccessPaidVideo(channelData, videoItem) {
  return isSubscribedToChannel(channelData) || isRented(videoItem) || isBought(videoItem);
}
export function canAccessFullVersionOfVideo(channelData, videoItem) {
  return isFree(videoItem) || canAccessPaidVideo(channelData, videoItem);
}
export function getBuyButtonDisplayType(channelData, videoItem) {
  if (canAccessPaidVideo(channelData, videoItem)) {
    return BUY_BUTTON_DISPLAY_TYPES.NONE;
  }
  return getBuyButtonDisplayTypeForPaidVideo(videoItem);
}
export function getBuyButtonDisplayTypeForPaidVideo(videoItem) {
  const _isRentEnabled = isRentEnabled(videoItem);
  const _isSaleEnabled = isSaleEnabled(videoItem);
  if (_isRentEnabled && _isSaleEnabled) {
    return BUY_BUTTON_DISPLAY_TYPES.BUY_FROM;
  } else if (_isSaleEnabled) {
    return BUY_BUTTON_DISPLAY_TYPES.BUY;
  } else if (_isRentEnabled) {
    return BUY_BUTTON_DISPLAY_TYPES.RENT;
  }
  return BUY_BUTTON_DISPLAY_TYPES.NONE;
}

// Todo: remove. Use widget/ui-selectors/video-access and overlay-texts
export function shouldShowSubscribeButton(_ref2) {
  let {
    settings,
    videoItem,
    channelData,
    showChannelCover
  } = _ref2;
  const hasChannelSubscription = isSubscribedToChannel(channelData);
  return hasSubscriptionPriceInfo(channelData) && !hasChannelSubscription && (!hasChannelSubscription && shouldShowChannelCover(settings, showChannelCover) || channelData.subscriptionOnly && !isFree(videoItem) && !isRented(videoItem) && !isBought(videoItem));
}
export function mainItemIsChannelCover(settings) {
  return settings.numbers.mainItemType === MAIN_ITEM_TYPE_VALUES.CHANNEL_COVER;
}
export function shouldShowChannelCover(settings, showChannelCover) {
  return showChannelCover && mainItemIsChannelCover(settings);
}

// Todo: remove. Use widget/ui-selectors/video-access and overlay-texts
export function getPlayButtonType(channelData, videoItem) {
  if (canAccessFullVersionOfVideo(channelData, videoItem)) {
    return PLAY_BUTTON_TYPES.PLAY;
  }
  return PLAY_BUTTON_TYPES.TRAILER_OR_PREVIEW;
}
export function hasSubscriptionPriceInfo(channelData) {
  return channelData ? Boolean(dealInfoHelpers.getSubscriptionPriceInfo(channelData.dealInfo || [])) : false;
}
export function isSubscribedToChannel(channelData) {
  return has(channelData, 'dgsInfo.subscription');
}
//# sourceMappingURL=overlay-buttons-utils.js.map